import React, { PropsWithChildren, useState, useEffect } from 'react';
import { Authenticator as AmplifyAuthenticator } from '@aws-amplify/ui-react';
import { Hub, Auth } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
// @ts-ignore
import conf from '../../aws-exports.js';
import './authstyle.css';

Auth.configure(conf);

export const Authenticator: React.FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState(false);

  useEffect(() => {
    const checkAuthState = async () => {
      try {
        const session = await Auth.currentSession();
        setIsAuthenticated(!!session);
      } catch (error) {
        setIsAuthenticated(false);
      }
      setLoading(false);
    };

    checkAuthState();

    const listener = (data: { payload: { event: string } }) => {
      if (data.payload.event === 'signIn') {
        setIsAuthenticated(true);
      } else if (data.payload.event === 'signOut') {
        setIsAuthenticated(false);
      }else if (data.payload.event === 'forgotPasswordSubmit') {
        setForgotPasswordSuccess(true);
        setTimeout(() => {
          setForgotPasswordSuccess(false);
        }, 5000);
      }
    };

    Hub.listen('auth', listener);
    return () => Hub.remove('auth', listener);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div style={{ display: 'flex', height: '100vh', width: '100vw' }}>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'auto',
          padding: '20px',
        }}
      >
        {forgotPasswordSuccess && (
          <div style={{ color: 'green', marginTop: '10px' }}>
            Password reset successful! You can now sign in with your new password.
          </div>
        )}
        <div style={{ width: '475px', marginBottom: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <img
              src='http://publicwebfilesx2nsat.s3.amazonaws.com/x2nSat-Logo-no-tagline.svg'
              alt='x2nSat Logo'
              style={{
                height: 'auto',
                maxHeight: '200px',
                width: 'auto',
                maxWidth: '45%',
                marginLeft: '2%',
                marginRight: '4%',
              }}
            />
            <hr
              style={{
                height: 'auto',
                width: '1px',
                backgroundColor: '#000',
                border: 'none',
              }}
            />
            <img
              src='http://publicwebfilesx2nsat.s3.amazonaws.com/Datadel_logo_Color.png'
              alt='Datadel Logo'
              style={{
                height: 'auto',
                maxHeight: '200px',
                width: 'auto',
                maxWidth: '45%',
              }}
            />
          </div>

          <AmplifyAuthenticator
            hideSignUp={true}
            formFields={{
              signIn: {
                username: {
                  label: 'Email',
                  placeholder: 'Enter your email',
                },
              },
              signUp: {
                username: {
                  label: 'Email',
                  placeholder: 'Enter your email',
                },
              },
            }}
          />
        </div>
      </div>
      <div className='arc-container'>
        <div className='satellite-image'></div>
        <div className='arc-large'></div>
        <div className='arc-medium'></div>
        <div className='arc-small'></div>
      </div>
    </div>
  );
};
